const c = (o, t) => ({ component: o, page: t, product: "product" });
export {
  c as logObject
};
//# sourceMappingURL=loggerUtil.js.map
